module.exports = __webpack_public_path__ + "static/media/مرشد سياحي في سويسرا.c0227446.jpg";